import { useEffect } from 'react'
import { useStore } from '@/store'

// Updates `nowTs` every second so components rendering relative time
// (e.g. "5s ago") re-render without each maintaining their own timer.
export function useWallClockTick(intervalMs = 1000) {
  const setNowTs = useStore(s => s.setNowTs)
  useEffect(() => {
    const id = setInterval(() => setNowTs(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [setNowTs, intervalMs])
}